import LoginLayout from '@/layouts/Login';
import CourseSurvey from '@/views/CourseSurvey/Index';

export default {
    path: '/course-survey',
    component: LoginLayout,
    children: [
        {
            path: ':token/:status',
            name: 'first_interview',
            component: CourseSurvey,
            meta: {
                auth: false,
            },
        },
    ],
};
